import { useCallback, useEffect, useState } from "react";

import { SessionOrganization } from "~/lib/auth/types";

import useUserSession from "./use-user-session";

export default function useCurrentOrganization() {
  const { userSession } = useUserSession();
  const [currentOrg, setCurrentOrg] = useState<SessionOrganization | null>(
    null,
  ); // State for organization

  const fetchOrg = useCallback(async () => {
    if (!userSession?.organizations) {
      setCurrentOrg(null);
      return;
    }

    let org;

    if (userSession?.org_id) {
      org = userSession.organizations.find(
        org => org.org_id === userSession?.org_id,
      );
    } else if (
      userSession?.organizations &&
      userSession.organizations.length > 0
    ) {
      org = userSession.organizations[0];
    }

    setCurrentOrg(org || null);
  }, [userSession]);

  useEffect(() => {
    fetchOrg();
  }, [fetchOrg]);

  return currentOrg; // Return the organization directly
}
